var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-abf1b550!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Propose.vue
// module id = 683
// module chunks = 1